export const PREVIEW_PAYLOAD = {
  contacts: {
    insurrer: {
      id: "e39e38fe-3a4f-4938-a8f4-e8667fdf6cdc",
      familySituation: null,
      fields: {
        familySituation: "MARRIED",
        teletransmission: true,
      },
      gender: "M",
      optMadelin: null,
      fullname: "Redouane EL FARHAOUI",
      firstname: "Redouane",
      birthName: null,
      maritalName: null,
      lastname: "El farhaoui",
      socialRegime: "SECURITE_SOCIALE",
      siretNumber: null,
      acceptDigital: true,
      acceptContact: true,
      politicallyExposedPerson: false,
      socialSecurityNumber: "193011212121270",
      birthDate: "01/01/1993",
      profession: "ACTIVE",
      socioProfessionalCategory: "OTHER",
      phone: "0687846224",
      email: "y.el.maache@gmail.com",
      landline: null,
      address: {
        fullAddress: "Villa keisser      ",
        repetitionIndex: " ",
        streetNumber: " ",
        street: " ",
        address: "Villa keisser",
        complement: " ",
        addressLocation: " ",
        residence: " ",
        zipCode: "29000",
        city: "Lyon",
        birthCity: " ",
        country: "1234578912",
        birthCountry: " ",
        departmentOfBirth: " ",
        mailBox: "",
        postalZipCode: "",
        postalCity: "",
      },
    },
    spouse: {
      id: null,
      contactId: null,
      firstname: "Jane",
      birthName: "Smith",
      maritalName: "Smith",
      lastname: "Smith",
      fullname: "Jane Smith",
      birthDate: "01/01/1993",
      gender: "F",
      email: "jane.smith@example.com",
      phone: "0687846225",
      socialRegime: "SECURITE_SOCIALE",
      socialSecurityNumber: "193011212121271",
      birthCountry: "France",
      birthCity: "Paris",
      departmentOfBirth: "75",
      address: {
        fullAddress: "Villa keisser      ",
        repetitionIndex: " ",
        streetNumber: " ",
        street: " ",
        address: "Villa keisser",
        complement: " ",
        addressLocation: " ",
        residence: " ",
        zipCode: "29000",
        city: "Lyon",
        birthCity: " ",
        country: "1234578912",
        birthCountry: " ",
        departmentOfBirth: " ",
        mailBox: "",
        postalZipCode: "",
        postalCity: "",
      },
    },
    children: [
      {
        firstname: "Jim",
        lastname: "Beam",
        fullname: "Jim Beam",
        birthDate: "01/01/2000",
        gender: "M",
        email: "jim.beam@example.com",
        phone: "0687846226",
        socialRegime: "SECURITE_SOCIALE",
        socialSecurityNumber: "193011212121272",
      },
      {
        firstname: "Jane",
        lastname: "Smith",
        fullname: "Jane Doe",
        birthDate: "01/01/2000",
        gender: "M",
        email: "jane.smith@example.com",
        phone: "0687846225",
        socialRegime: "SECURITE_SOCIALE",
        socialSecurityNumber: "193011212121271",
      },
    ],
  },
  organization: {
    name: "Mcci",
    address: "38-42 RUE CUVIER",
    zipCode: "93100",
    city: "Montreuil",
    email: " ",
    phone: " ",
  },
  ownedBy: {
    id: "cm73i6x3b001m3j6rqdaccims",
    createdDate: "2026-04-23T15:35:04.178Z",
    updatedDate: "2026-04-23T15:38:02.205Z",
    deletedDate: null,
    active: true,
    icon: null,
    type: "OTHER",
    form: null,
    billingCycle: "MONTHLY",
    name: "Mcci",
    siretNumber: null,
    config: {
      envelop: "MCCI",
      template: "MCCI_HEALTH",
      AUTHENTICATION_MODE: "no_otp",
      YOUSIGN_KEY_SANDBOX: "z5KLrXMlsI6x523mYQ9CMQWYVyet6Iaz",
      YOUSIGN_URL_SANDBOX: "https://api-sandbox.yousign.app/v3/",
    },
    additionalInfo: {},
    alias: null,
  },
  broker: {
    status: "superviseur",
    isInternal: true,
    code: "123465",
    socialReason: "01062026",
    orias: "123456",
    rcsNumber: "12345678901",
  },
  insurancePlan: {
    icon: null,
    id: "cmobo21o700003j70htbqj3st",
    name: "Produit de test",
    category: "SENIOR",
    risk: "health",
    config: {},
    fields: {},
    alias: null,
    product: null,
    cost: 83.7,
    adherentCost: 83.7,
    costDetails: {
      adherentCost: 83.7,
    },
    tax: null,
    administrativeFees: null,
    currency: "EUR",
    justification: "Hello",
  },
  offers: [],
  insurancePlans: [
    {
      icon: null,
      id: "cmobo21o700003j70htbqj3st",
      name: "Produit de test",
      category: "SENIOR",
      risk: "health",
      fields: {},
      alias: null,
      cost: 83.7,
      adherentCost: 83.7,
      costDetails: {
        adherentCost: 83.7,
      },
      tax: null,
      administrativeFees: null,
      config: {},
      currency: "EUR",
      justification: "Hello",
    },
  ],
  project: {
    number: 9,
    id: "cmod15w7v000be8jqguzg5lk6",
    ria: false,
    effectiveDate: "12102025",
    operationNature: null,
    fees: 120,
    terminationRequest: null,
    additionalInfo: {
      brokerageFees: 120,
      generatedDocuments: {
        DUTY_OF_ADVICE_QUOTE: "cmod1ujzt000344jq8mtr7p3s",
      },
    },
    needs: {
      dental: 2,
      optical: 2,
      hearingAid: 2,
      Médecinedouce: 2,
      hospitalization: 2,
      medicalExpenses: 2,
    },
    fields: {
      info: {
        cmuBeneficiary: true,
        ccChiBeneficiary: true,
        protectionRegime: true,
        fonctionnaryOrAgent: true,
        participationCollectiveBeneficiary: true,
      },
      needs: {
        dental: 2,
        optical: 2,
        hearingAid: 2,
        Médecinedouce: 2,
        hospitalization: 2,
        medicalExpenses: 2,
      },
      budget: {
        max: 150,
        min: 10,
      },
      skills: {},
      deltaEnd: 0,
      deltaStart: 1,
      quoteNumber: {
        cmobo21o700003j70htbqj3st: 28,
      },
      insurancePlans: ["cmobo21o700003j70htbqj3st"],
      justifications: {
        cmobo21o700003j70htbqj3st: "Hello",
      },
      processTemplate: "B2B_RADIANCE_AURA_TER",
      selectedToCompare: ["cmobo21o700003j70htbqj3st"],
    },
    hasResponsible: true,
  },
  author: {
    id: "cmd774xx3b001m3j6djjie68dn",
    meta: {
      type: "supervisor.internal",
    },
    lastname: "Mcci",
    firstname: "Superviseur",
    email: "contact+mcci.superviseur@kayros.tech",
    phone: "0666666666",
    city: "",
    zipCode: "",
    address: "",
    fullname: "MCCI Superviseur",
  },
  payment: {
    id: "e16233fc-dcda-495f-a37e-f65735c562b5",
    createdDate: "2026-04-24T15:04:22.191Z",
    updatedDate: "2026-04-24T15:04:22.191Z",
    deletedDate: null,
    type: "DEBIT",
    frequency: "MONTHLY",
    debitDay: "8",
    payer: {
      id: "b9981725-e63d-458b-a278-26b5c2714b28",
      createdDate: "2026-04-24T15:04:22.191Z",
      updatedDate: "2026-04-24T15:04:22.191Z",
      deletedDate: null,
      BIC: "PSSTNTTSS",
      IBAN: "FR1420041010050500013M02606",
      owner: {
        id: "49c84865-49e3-4000-ad75-ff2aeae6c827",
        createdDate: "2026-04-24T15:04:22.191Z",
        updatedDate: "2026-04-24T15:04:22.191Z",
        deletedDate: null,
        type: "PARTICULAR",
        gender: null,
        firstName: "Redouane",
        lastName: "EL FARHAOUI",
        socialReason: null,
        isAdherent: true,
        telecoms: [
          {
            id: "2523a7f7-588e-47d3-a794-93c0bb7ec971",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "ZIP_CODE",
            value: "69001",
          },
          {
            id: "7d9ea487-7b9c-416f-a31e-13dfb486b41c",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "PHONE",
            value: "0687846224",
          },
          {
            id: "d4187582-3f62-47d5-a20c-bf331386dc00",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "CITY",
            value: "Lyon",
          },
          {
            id: "5bc17577-2dcc-4651-b400-35fefce5bda7",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "LANDLINE",
            value: null,
          },
          {
            id: "a5f63b29-ac5c-42a7-bd78-c7b759f335a3",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "EMAIL",
            value: "y.el.maache@gmail.com",
          },
          {
            id: "695db0e6-9e3e-441f-9bbf-5bd8fa819f85",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "ADDRESS",
            value: "Villa keisser",
          },
        ],
      },
      gender: "M",
      address: {
        fullAddress: "Villa keisser      ",
        ZIP_CODE: "69001",
        PHONE: "0687846224",
        CITY: "Lyon",
        LANDLINE: null,
        EMAIL: "y.el.maache@gmail.com",
        ADDRESS: "Villa keisser",
      },
    },
    receiver: {
      id: "cc8f2bd7-112b-4df5-bf42-01e5fa1acf7f",
      createdDate: "2026-04-24T15:04:22.191Z",
      updatedDate: "2026-04-24T15:04:22.191Z",
      deletedDate: null,
      BIC: "PSSTNTTSS",
      IBAN: "FR1420041010050500013M02606",
      owner: {
        id: "4d411af4-7e8a-460c-b6f1-ea079425e8fb",
        createdDate: "2026-04-24T15:04:22.191Z",
        updatedDate: "2026-04-24T15:04:22.191Z",
        deletedDate: null,
        type: "PARTICULAR",
        gender: null,
        firstName: "Redouane",
        lastName: "EL FARHAOUI",
        socialReason: null,
        isAdherent: true,
        telecoms: [
          {
            id: "65373725-9cf6-4190-9e85-354465a9dfa5",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "ZIP_CODE",
            value: "69001",
          },
          {
            id: "84c2c023-06e6-40ab-8113-264234ac1837",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "PHONE",
            value: "0687846224",
          },
          {
            id: "7f37cf17-6c53-4e8c-a2f3-833ccdce4d63",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "CITY",
            value: "Lyon",
          },
          {
            id: "34f8bd18-5a9e-4144-a1dc-79dd16ce4b5c",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "LANDLINE",
            value: null,
          },
          {
            id: "b7a71cf3-e3b2-47b0-a23a-31cb1563f32c",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "EMAIL",
            value: "y.el.maache@gmail.com",
          },
          {
            id: "18597da1-5765-49f4-a4d9-3a0ecff89c4c",
            createdDate: "2026-04-24T15:04:22.191Z",
            updatedDate: "2026-04-24T15:04:22.191Z",
            deletedDate: null,
            use: "WORK",
            system: "ADDRESS",
            value: "Villa keisser",
          },
        ],
      },
    },
    payerFullName: "",
  },
  loggedUser: {
    type: "supervisor.internal",
  },
  needsConfig: {
    id: "cmobnd0tr000elwjqhw73glta",
    createdDate: "2025-12-26T13:32:46.017Z",
    updatedDate: "2026-04-23T23:30:13.802Z",
    deletedDate: null,
    type: "NEEDS",
    value: {
      labels: {
        1: "Économique",
        2: "Moyen",
        3: "Confort",
        4: "Élevé",
        5: "Trés élevé",
      },
      categories: {
        clyx1nqb600042v6qq3tmqpef: {
          1: {
            text: "Pas",
            label: "Hospitalisation",
            subtitle: "Pas de prise en charge souhaitée",
            description: "Hospitalisation - Chirurgien (signataire DPTM) :",
          },
          2: {
            text: "faible",
            label: "Hospitalisation",
            subtitle: "Remboursement faible",
            description: "Hospitalisation - Chirurgien (signataire DPTM) :",
          },
          3: {
            text: "intermédiaire",
            label: "Hospitalisation",
            subtitle: "Remboursement intermédiaire",
            description: "Hospitalisation - Chirurgien (signataire DPTM) :",
          },
          4: {
            text: "élevé",
            subtitle: "Remboursement élevé",
          },
          5: {
            text: "très élevé",
            subtitle: "Remboursement très élevé",
          },
        },
        clyx1p4go00062v6qrl5ixpef: {
          1: {
            text: "Pas",
            label: "Soins courants",
            subtitle: "Pas de prise en charge souhaitée",
            description: "Soins courants - Spécialistes (signataire DPTM) :",
          },
          2: {
            text: "faible",
            label: "Soins courants",
            subtitle: "Remboursement faible",
            description: "Soins courants - Spécialistes (signataire DPTM) :",
          },
          3: {
            text: "intermédiaire",
            label: "Soins courants",
            subtitle: "Remboursement intermédiaire",
            description: "Soins courants - Spécialistes (signataire DPTM) :",
          },
          4: {
            text: "élevé",
            subtitle: "Remboursement élevé",
          },
          5: {
            text: "très élevé",
            subtitle: "Remboursement très élevé",
          },
        },
        clyx1rvbx000b2v6qb5zsnpef: {
          1: {
            text: "Pas",
            label: "Dentaire",
            subtitle: "Pas de prise en charge souhaitée",
            description:
              "Dentaire (prothèses dentaires fixes acceptées par la Sécurité Sociale hors 100% santé) :",
          },
          2: {
            text: "faible",
            label: "Dentaire",
            subtitle: "Remboursement faible",
            description:
              "Dentaire (prothèses dentaires fixes acceptées par la Sécurité Sociale hors 100% santé) :",
          },
          3: {
            text: "intermédiaire",
            label: "Dentaire",
            subtitle: "Remboursement intermédiaire",
            description:
              "Dentaire (prothèses dentaires fixes acceptées par la Sécurité Sociale hors 100% santé) :",
          },
          4: {
            text: "élevé",
            subtitle: "Remboursement élevé",
          },
          5: {
            text: "très élevé",
            subtitle: "Remboursement très élevé",
          },
        },
        clyx1tfeh000d2v6q7fy6ipef: {
          1: {
            text: "Pas",
            label: "Optique",
            subtitle: "Pas de prise en charge souhaitée",
            description:
              "Équipement monture + verres simples (hors 100% santé) :",
          },
          2: {
            text: "faible",
            label: "Optique",
            subtitle: "Remboursement faible",
            description:
              "Équipement monture + verres simples (hors 100% santé) :",
          },
          3: {
            text: "intermédiaire",
            label: "Optique",
            subtitle: "Remboursement intermédiaire",
            description:
              "Équipement monture + verres simples (hors 100% santé) :",
          },
          4: {
            text: "élevé",
            subtitle: "Remboursement élevé",
          },
          5: {
            text: "très élevé",
            subtitle: "Remboursement très élevé",
          },
        },
        clyx1v34j000g2v6q2fcppefs: {
          1: {
            text: "Pas",
            label: "Aides auditives",
            subtitle: "Pas de prise en charge souhaitée",
            description: "Prothèses audio :",
          },
          2: {
            text: "faible",
            label: "Aides auditives",
            subtitle: "Remboursement faible",
            description: "Prothèses audio :",
          },
          3: {
            text: "intermédiaire",
            label: "Aides auditives",
            subtitle: "Remboursement intermédiaire",
            description: "Prothèses audio :",
          },
          4: {
            text: "élevé",
            label: "Aides auditives",
            subtitle: "Remboursement élevé",
            description: "Prothèses audio :",
          },
          5: {
            text: "très élevé",
            label: "Aides auditives",
            subtitle: "Remboursement très élevé",
            description: "Prothèses audio :",
          },
        },
        cmoc44xou00093j70i1ga4bch: {
          1: {
            text: "Pas",
            label: "Médecine douce",
            subtitle: "Pas de prise en charge souhaitée",
            description: "Médecine douce :",
          },
          2: {
            text: "faible",
            label: "Médecine douce",
            subtitle: "Remboursement faible",
            description: "Médecine douce :",
          },
          3: {
            text: "intermédiaire",
            label: "Médecine douce",
            subtitle: "Remboursement intermédiaire",
            description: "Médecine douce :",
          },
          4: {
            text: "élevé",
            label: "Médecine douce",
            subtitle: "Remboursement élevé",
            description: "Médecine douce :",
          },
          5: {
            text: "très élevé",
            label: "Médecine douce",
            subtitle: "Remboursement très élevé",
            description: "Médecine douce :",
          },
        },
      },
      needsLevels: 5,
    },
  },
  recommended: {
    id: "cmod16jg7000ge8jq569z468o",
    createdDate: "2026-04-24T14:53:51.226Z",
    updatedDate: "2026-04-24T14:53:51.226Z",
    deletedDate: null,
    cost: 83.7,
    billingPeriod: "MONTHLY",
    tax: null,
    administrativeFees: null,
    currency: "EUR",
    recommended: null,
    recommandationScore: null,
    recommendationScore: null,
    costDetails: {
      adherentCost: 83.7,
    },
    groupSize: null,
    comment: null,
    costMoney: null,
    project: {
      id: "cmod15w7v000be8jqguzg5lk6",
      createdDate: "2026-04-24T14:53:21.133Z",
      updatedDate: "2026-05-04T22:02:12.109Z",
      deletedDate: null,
      externalId: null,
      name: null,
      product: null,
      ria: false,
      hasResponsible: true,
      projectType: "HOT",
      expired: true,
      visible: true,
      fields: {
        info: {
          cmuBeneficiary: true,
          ccChiBeneficiary: true,
          protectionRegime: true,
          fonctionnaryOrAgent: true,
          participationCollectiveBeneficiary: true,
        },
        needs: {
          dental: 2,
          optical: 2,
          hearingAid: 2,
          Médecinedouce: 2,
          hospitalization: 2,
          medicalExpenses: 2,
        },
        budget: {
          max: 150,
          min: 10,
        },
        skills: {},
        deltaEnd: 0,
        deltaStart: 1,
        quoteNumber: {
          cmobo21o700003j70htbqj3st: 28,
        },
        insurancePlans: ["cmobo21o700003j70htbqj3st"],
        justifications: {
          cmobo21o700003j70htbqj3st: "Hello",
        },
        processTemplate: "B2B_RADIANCE_AURA_TER",
        selectedToCompare: ["cmobo21o700003j70htbqj3st"],
      },
      externalManagement: {},
      traceability: null,
      locked: false,
      retroactive: false,
    },
    commission: null,
    insurancePlan: {
      id: "cmobo21o700003j70htbqj3st",
      createdDate: "2026-04-23T15:59:43.025Z",
      updatedDate: "2026-05-08T14:35:50.918Z",
      deletedDate: null,
      identifier: "cmobo3dnt000c3j7069zc0wg7",
      externalId: null,
      product: null,
      status: "ACTIVE",
      risk: "health",
      name: "Produit de test",
      category: "SENIOR",
      level: null,
      alias: null,
      aliases: null,
      coverageArea: null,
      contact: null,
      endpoint: null,
      startDate: null,
      endDate: null,
      zoneType: null,
      description: null,
      banner: null,
      icon: null,
      active: true,
      internal: true,
      isStandalone: true,
      fields: {},
      config: {},
      recommendationRules: {},
      supportingInformation: [],
      params: [
        {
          id: "cmobo2cud00013j70noujh7ak",
          createdDate: "2026-04-23T15:59:43.025Z",
          updatedDate: "2026-04-23T15:59:43.025Z",
          deletedDate: null,
          rules: [
            {
              id: "cmox0p6ts00003j70bvp5j4vy",
              createdDate: "2026-05-08T14:35:50.918Z",
              updatedDate: "2026-05-08T14:35:50.918Z",
              deletedDate: null,
              name: "DOCUMENTS",
              value: [
                {
                  documents: [
                    {
                      process: "cmobnd0tr000clwjqe50p40ppm",
                      documentName: "DUTY_OF_ADVICE_QUOTE",
                      documentVersion: "DEFAULT",
                    },
                  ],
                },
              ],
              accessor: null,
            },
            {
              id: "cmobo3dnt000b3j70jt3vsgbl",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T16:03:05.866Z",
              deletedDate: null,
              name: "SOCIAL_REGIMES",
              value: [
                "SECURITE_SOCIALE",
                "ALSACE_MOSELLE",
                "REGIME_SPECIAL",
                "REGIME_SALARIES_AGRICOLES",
                "SECURITE_SOCIALE_INDEPENDANTS",
              ],
              accessor: null,
            },
            {
              id: "cmobo3dnt00033j70sxrwhoas",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T16:03:05.866Z",
              deletedDate: null,
              name: "DELTA_START",
              value: 1,
              accessor: null,
            },
            {
              id: "cmobo7qal00023j6zh9f9id4t",
              createdDate: "2026-04-23T16:03:05.866Z",
              updatedDate: "2026-04-23T16:03:05.866Z",
              deletedDate: null,
              name: "ZIP_CODES",
              value: ["69001"],
              accessor: null,
            },
            {
              id: "cmobo7qal00013j6zl9gi3kk5",
              createdDate: "2026-04-23T16:03:05.866Z",
              updatedDate: "2026-04-23T16:03:05.866Z",
              deletedDate: null,
              name: "DEPARTMENTS",
              value: ["69"],
              accessor: null,
            },
            {
              id: "cmobo3dnt000a3j70ky4u119a",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "DELTA_END_RIA",
              value: 0,
              accessor: null,
            },
            {
              id: "cmobo3dnt00093j70qv5c4v6j",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "DELTA_END",
              value: 0,
              accessor: null,
            },
            {
              id: "cmobo3dnt00083j70omr1lk4y",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "DELTA_START_RIA",
              value: 0,
              accessor: null,
            },
            {
              id: "cmobo3dnt00073j70xb7psdes",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "MAX_AGE",
              value: 99,
              accessor: null,
            },
            {
              id: "cmobo3dnt00063j70bb2rvaxh",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "MIN_AGE",
              value: 18,
              accessor: null,
            },
            {
              id: "cmobo3dnt00043j70xjk3epuk",
              createdDate: "2026-04-23T15:59:43.025Z",
              updatedDate: "2026-04-23T15:59:43.025Z",
              deletedDate: null,
              name: "PROCESSES",
              value: ["cmobnd0tr000clwjqe50p40ppm"],
              accessor: null,
            },
          ],
        },
      ],
      distributions: [
        {
          id: "cmobo3e42000d3j70q7e48688",
          createdDate: "2026-04-23T15:59:43.711Z",
          updatedDate: "2026-04-24T15:08:14.710Z",
          deletedDate: null,
          broker: null,
          commissions: [],
        },
        {
          id: "cmobo21o700003j70htbqj3st",
          createdDate: "2026-04-27T12:42:51.468Z",
          updatedDate: "2026-04-27T12:42:51.468Z",
          deletedDate: null,
          broker: {
            id: "cm73i6x3b001m3j6rqdaccims",
            createdDate: "2026-04-23T15:35:04.178Z",
            updatedDate: "2026-04-24T15:11:54.939Z",
            deletedDate: null,
            status: null,
            socialReason: "MUTUELLE DES CHAMBRES COMMERCE INDUSTRIE",
            code: null,
            orias: null,
            isInternal: true,
            rcsNumber: null,
            sirenNumber: null,
            rcsPlace: null,
            additionalInfo: null,
            internal: false,
            organization: {
              id: "cm73i6x3b001m3j6rqdaccims",
              createdDate: "2026-04-23T15:35:04.178Z",
              updatedDate: "2026-04-23T15:38:02.205Z",
              deletedDate: null,
              active: true,
              icon: null,
              type: "OTHER",
              form: null,
              billingCycle: "MONTHLY",
              name: "Mcci",
              siretNumber: null,
              config: {
                envelop: "MCCI",
                template: "MCCI_HEALTH",
                AUTHENTICATION_MODE: "no_otp",
                YOUSIGN_KEY_SANDBOX: "z5KLrXMlsI6x523mYQ9CMQWYVyet6Iaz",
                YOUSIGN_URL_SANDBOX: "https://api-sandbox.yousign.app/v3/",
              },
              additionalInfo: {},
              alias: null,
            },
          },
          commissions: [],
        },
      ],
      insurancePlanCoverages: [],
      ownedBy: {
        id: "cm73i6x3b001m3j6rqdaccims",
        createdDate: "2026-04-23T15:35:04.178Z",
        updatedDate: "2026-04-23T15:38:02.205Z",
        deletedDate: null,
        active: true,
        icon: null,
        type: "OTHER",
        form: null,
        billingCycle: "MONTHLY",
        name: "Mcci",
        siretNumber: null,
        config: {
          envelop: "MCCI",
          template: "MCCI_HEALTH",
          AUTHENTICATION_MODE: "no_otp",
          YOUSIGN_KEY_SANDBOX: "z5KLrXMlsI6x523mYQ9CMQWYVyet6Iaz",
          YOUSIGN_URL_SANDBOX: "https://api-sandbox.yousign.app/v3/",
        },
        additionalInfo: {},
        alias: null,
        categoryWeight: null,
      },
    },
  },
  recommendationNeeds: [],
};
